import React from 'react';
import AdminLayout from '../../../../Components/CommonComponents/Layout/adminLayout';
import AddChapterContainer from '../../../../Containers/AdminContainer/Chapters/AddChapter';
const AddChapterScreen = () => {
  return <AddChapterContainer />;
};

export default AddChapterScreen;
